export type MobileQuickActionRole = "admin" | "funcionario" | "caixa" | "recepcionista";
export type MobileQuickActionIcon = "calendar" | "payment" | "client" | "queue" | "clock" | "commission" | "product";

export type MobileQuickAction = {
  label: string;
  description: string;
  path: string;
  icon: MobileQuickActionIcon;
  tone: string;
};

const ACTIONS_BY_ROLE: Record<MobileQuickActionRole, MobileQuickAction[]> = {
  admin: [
    { label: "Novo agendamento", description: "Abra a agenda para reservar um horário", path: "/weekly-calendar", icon: "calendar", tone: "bg-amber-100 text-amber-700" },
    { label: "Receber pagamento", description: "Finalize atendimentos pendentes", path: "/checkout", icon: "payment", tone: "bg-emerald-100 text-emerald-700" },
    { label: "Acompanhar fila", description: "Veja clientes aguardando e em preparo", path: "/painel-chamada", icon: "queue", tone: "bg-violet-100 text-violet-700" },
    { label: "Novo cliente", description: "Abra o cadastro de clientes", path: "/clients", icon: "client", tone: "bg-blue-100 text-blue-700" },
  ],
  recepcionista: [
    { label: "Novo agendamento", description: "Abra a agenda para reservar um horário", path: "/weekly-calendar", icon: "calendar", tone: "bg-amber-100 text-amber-700" },
    { label: "Agenda do dia", description: "Confira os próximos atendimentos", path: "/appointments", icon: "calendar", tone: "bg-blue-100 text-blue-700" },
    { label: "Acompanhar fila", description: "Veja clientes aguardando e em preparo", path: "/painel-chamada", icon: "queue", tone: "bg-violet-100 text-violet-700" },
    { label: "Receber pagamento", description: "Direcione para o caixa", path: "/checkout", icon: "payment", tone: "bg-emerald-100 text-emerald-700" },
  ],
  caixa: [
    { label: "Receber pagamento", description: "Abra os atendimentos pendentes", path: "/checkout", icon: "payment", tone: "bg-emerald-100 text-emerald-700" },
    { label: "Ver fila", description: "Acompanhe clientes em atendimento", path: "/painel-chamada", icon: "queue", tone: "bg-violet-100 text-violet-700" },
    { label: "Produtos", description: "Consulte produtos e vendas", path: "/products", icon: "product", tone: "bg-orange-100 text-orange-700" },
  ],
  funcionario: [
    { label: "Minha agenda", description: "Veja o seu próximo atendimento", path: "/weekly-calendar", icon: "calendar", tone: "bg-amber-100 text-amber-700" },
    { label: "Bater ponto", description: "Registre sua jornada de hoje", path: "/clock-in", icon: "clock", tone: "bg-blue-100 text-blue-700" },
    { label: "Comissões", description: "Consulte seu extrato pessoal", path: "/my-commissions", icon: "commission", tone: "bg-emerald-100 text-emerald-700" },
  ],
};

export function getMobileQuickActions(role: MobileQuickActionRole, visiblePaths: string[]) {
  return ACTIONS_BY_ROLE[role].filter((action) => visiblePaths.includes(action.path));
}
